import { render, staticRenderFns } from "./feedbackDetail.vue?vue&type=template&id=da5cfb10&"
import script from "./feedbackDetail.vue?vue&type=script&lang=js&"
export * from "./feedbackDetail.vue?vue&type=script&lang=js&"
import style0 from "./feedbackDetail.vue?vue&type=style&index=0&id=da5cfb10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports